import { render } from "./TransactionDetailPanel.vue?vue&type=template&id=d7a5082a&ts=true"
import script from "./TransactionDetailPanel.vue?vue&type=script&lang=ts"
export * from "./TransactionDetailPanel.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__